import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import actions from 'redux-auto'

export function useUserInfo(userId) {
  const userInfo = useSelector(state => state.userInfo.users[userId])
  const isLoading = useSelector(state => state.userInfo.isFetching[userId])
  useEffect(() => {
    if (!userInfo && !isLoading && userId) {
      actions.userInfo.getUserInfo({userId})
    }
  }, [userId, isLoading])
  if (!userInfo) {
    return null
  }

  return {
    ...userInfo,
  }
}
